import {
    Table, TableBody, TableRow, TableCell, TableContainer, TableHead,
    Paper, Stack, IconButton, Dialog, DialogContent,
    Box, Typography, Chip,
    useMediaQuery,useTheme
} from "@mui/material";
import helpers from "../../../hooks/HelperFunctions";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useState } from "react";



const HEAD_STYLES = {
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.80)',
    fontFamily: 'Quicksand',
    letterSpacing: 0.8,
    background: 'linear-gradient(135deg, #1C1C2E 0%, #2D1A5E 100%)',
    borderBottom: 'none',
    py: 2.0,
};

const CELL_STYLES = {
    fontSize: 14,
    fontFamily: 'Quicksand',
    fontWeight: 600,
    color: '#374151',
    borderBottom: '1px solid rgba(0,0,0,0.04)',
    py: 2.0,
};

const PAYMENT_STATUS = {
    'S': { label: 'Success',  bgColor: '#D1FAE5', textColor: '#065F46' },
    'W': { label: 'Waiting',  bgColor: '#F3F4F6', textColor: '#374151' },
    'A': { label: 'Applied',  bgColor: '#FEF3C7', textColor: '#92400E' },
    'P': { label: 'Pending',  bgColor: '#DBEAFE', textColor: '#1E40AF' },
};

// Always allocate 3px on the left so hover does not shift layout.
// Transition only the color, not the width.
const ROW_HOVER = {
    '& td:first-of-type': {
        borderLeft: '3px solid transparent',
        transition: 'border-left-color 0.15s ease',
    },
    '&:hover': {
        bgcolor: '#FFF5F0',
        '& td:first-of-type': { borderLeftColor: '#FF5200' },
    },
    transition: 'background-color 0.15s ease',
};

function formatDate(date) {
    if (!date) return '—';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Asia/Kolkata' });
}
function MobilePaymentCard({ campaign, index, onView }) {
    return (
        <Paper
            sx={{
                borderRadius: 3,
                p: 2,
                border: '1px solid rgba(255,82,0,0.08)',
                boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
                transition: 'all .2s ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                },
            }}
        >
            <Stack spacing={1.5}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <Typography
                        sx={{
                            fontSize: 15,
                            fontWeight: 700,
                            fontFamily: 'Quicksand',
                            color: '#0F172A',
                            flex: 1,
                            minWidth: 0,
                            whiteSpace:'nowrap',
                            overflow:'hidden',
                            textOverflow:'ellipsis'
                        }}
                    >
                        {campaign?.campaign?.name}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: 11,
                            color: '#9CA3AF',
                            ml: 1,
                        }}
                    >
                        #{index + 1}
                    </Typography>
                </Stack>

                <Typography
                    sx={{
                        fontSize: 12,
                        color: '#6B7280',
                    }}
                >
                    {formatDate(campaign?.payments?.[0]?.date)}
                </Typography>

                <Box>
                    <Typography
                        sx={{
                            fontSize: 11,
                            color: '#9CA3AF',
                            mb: 0.5,
                        }}
                    >
                        Deliverables
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: 13,
                            fontWeight: 600,
                        }}
                    >
                        {campaign?.payments?.[0]?.deliverables || '—'}
                    </Typography>
                </Box>

                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Box>
                        <Typography
                            sx={{
                                fontSize: 11,
                                color: '#9CA3AF',
                            }}
                        >
                            Amount
                        </Typography>

                        <Typography
                            sx={{
                                color: '#FF5200',
                                fontWeight: 800,
                                fontSize: 18,
                                fontFamily: 'Quicksand',
                            }}
                        >
                            {helpers.formatNumber(
                                campaign?.totalPaid,
                                true
                            )}
                        </Typography>
                    </Box>

                    <IconButton
                        onClick={() => onView(campaign)}
                        sx={{
                            color: '#FF5200',
                            bgcolor: 'rgba(255,82,0,0.08)',
                            '&:hover': {
                                bgcolor: 'rgba(255,82,0,0.12)',
                            },
                        }}
                    >
                        <ReceiptLongIcon />
                    </IconButton>
                </Stack>
            </Stack>
        </Paper>
    );
}

function PaymentLedgerTable({ content }) {
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const theme  = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    if (!content?.length) {
    return (
        <Paper
            sx={{
                mt: 3,
                p: 4,
                textAlign: 'center',
                borderRadius: 3,
            }}
        >
            <Typography
                sx={{
                    fontFamily: 'Quicksand',
                    fontWeight: 600,
                }}
            >
                No payment records found
            </Typography>
        </Paper>
    );
}
    return (
        <>
          
            {isMobile ? (
    <Stack spacing={2} mt={3}>
        {content?.map((c, index) => (
            <MobilePaymentCard
                key={c?.campaign?._id ?? index}
                campaign={c}
                index={index}
                onView={setSelectedCampaign}
            />
        ))}
    </Stack>
) : (
    <Box
        sx={{
            marginTop: 3,
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
            border: '1px solid rgba(255,82,0,0.08)',
        }}
    >
        <TableContainer
            component={Paper}
            sx={{
                maxHeight: 420,
                overflowX: 'auto',
                boxShadow: 'none',
            }}
        >
            <Table
                stickyHeader
                sx={{
                    minWidth: 700,
                }}
            >
                      <TableHead>
                            <TableRow>
                                <TableCell sx={{ ...HEAD_STYLES, minWidth: 48 }}>#</TableCell>
                                <TableCell sx={{ ...HEAD_STYLES, minWidth: 110 }}>Date</TableCell>
                                <TableCell sx={{ ...HEAD_STYLES, minWidth: 180 }}>Campaign</TableCell>
                                <TableCell sx={{ ...HEAD_STYLES, minWidth: 140 }}>Deliverables</TableCell>
                                <TableCell sx={{ ...HEAD_STYLES, minWidth: 110 }}>Amount</TableCell>
                                <TableCell sx={{ ...HEAD_STYLES, minWidth: 80, textAlign: 'center' }}>Details</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {content.map((c, index) => (
                                <TableRow key={c?.campaign?._id ?? index} sx={ROW_HOVER}>
                                    <TableCell sx={{ ...CELL_STYLES, color: '#9CA3AF', fontSize: 12 }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell sx={CELL_STYLES}>
                                        {formatDate(c?.payments?.[0]?.date)}
                                    </TableCell>
                                    {/* <TableCell sx={{ ...CELL_STYLES, fontWeight: 700, color: '#0F172A' }}>
                                        {c?.campaign?.name}
                                    </TableCell> */}
                                    <TableCell
                                    title={c?.campaign?.name}
                                    sx={{
                                        ...CELL_STYLES,
                                        fontWeight: 700,
                                        color: '#0F172A',maxWidth: 250,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}>
                                        {c?.campaign?.name}
                                    </TableCell>
                                    <TableCell sx={CELL_STYLES}>
                                        {c?.payments?.[0]?.deliverables || '—'}
                                    </TableCell>
                                    <TableCell sx={{ ...CELL_STYLES, color: '#FF5200', fontWeight: 800 }}>
                                        {helpers.formatNumber(c?.totalPaid, true)}
                                    </TableCell>
                                    <TableCell sx={{ ...CELL_STYLES, textAlign: 'center' }}>
                                        <IconButton
                                            title="View all payments"
                                            size="small"
                                            onClick={() => setSelectedCampaign(c)}
                                            sx={{
                                                color: '#FF5200',
                                                '&:hover': { bgcolor: 'rgba(255,82,0,0.08)' },
                                            }}
                                        >
                                            <ReceiptLongIcon sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
           
            </Table>
        </TableContainer>
    </Box>
)}

            {/* Payment breakdown dialog */}
            <Dialog
                open={!!selectedCampaign}
                onClose={() => setSelectedCampaign(null)}
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
                fullScreen={isMobile}
            >
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #1C1C2E 0%, #2D1A5E 100%)',
                        px: {xs:2,sm:3},
                        py: {xs:2,sm:2.5},
                    }}
                >
                    <Typography sx={{ fontFamily: 'Quicksand', fontWeight: 800, color: '#FFFFFF', fontSize: 16 }}>
                        Payment Breakdown
                    </Typography>
                    <Typography sx={{ fontFamily: 'Quicksand', fontWeight: 700, color: '#FF5200', fontSize: {xs:18,sm:22} }}>
                        {helpers.formatNumber(selectedCampaign?.totalPaid, true)}
                    </Typography>
                    <Typography sx={{ fontFamily: 'Quicksand', fontWeight: 600, color: 'rgba(255,255,255,0.55)', fontSize: 13 }}>
                        {selectedCampaign?.campaign?.name}
                    </Typography>
                </Box>

                <DialogContent sx={{ background: '#F8FAFC', p: {xs:2,sm:3} }}>
                    <Stack direction="row" flexWrap="wrap" gap={2}>
                        {selectedCampaign?.payments?.map((payment, index) => (
                            <Box
                                key={index}
                                sx={{
                                    width:{
                                        xs:'100%',
                                        sm:'calc(50% - 8px)'
                                    },
                                    background: '#FFFFFF',
                                    borderRadius: 2,
                                    p: 2,
                                    border: '1px solid rgba(0,0,0,0.06)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    flexShrink:0,
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0, left: 0,
                                        width: 3, height: '100%',
                                        background: 'linear-gradient(180deg, #FF5200 0%, #FF8C42 100%)',
                                        borderRadius: '3px 0 0 3px',
                                    },
                                }}
                            >
                                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                                    <Box>
                                        <Typography
                                            sx={{ fontSize: {xs:18,sm:22}, fontWeight: 900, fontFamily: 'Quicksand', color: '#0F172A' }}
                                        >
                                            {helpers.formatNumber(payment.amount, true)}
                                        </Typography>
                                        <Typography sx={{ fontSize: 12, fontFamily: 'Quicksand', color: '#6B7280', mt: 0.25 }}>
                                            {formatDate(payment.date)}
                                        </Typography>
                                        {payment.createdby && (
                                            <Typography sx={{ fontSize: 11, fontFamily: 'Quicksand', color: '#9CA3AF', mt: 0.25 }}>
                                                By {payment.createdby}
                                            </Typography>
                                        )}
                                    </Box>
                                    {PAYMENT_STATUS[payment.status] && (
                                        <Chip
                                            label={PAYMENT_STATUS[payment.status].label}
                                            size="small"
                                            sx={{
                                                bgcolor: PAYMENT_STATUS[payment.status].bgColor,
                                                color: PAYMENT_STATUS[payment.status].textColor,
                                                fontFamily: 'Quicksand',
                                                fontWeight: 700,
                                                fontSize: 10,
                                                height: 20,
                                            }}
                                        />
                                    )}
                                </Stack>
                            </Box>
                        ))}
                    </Stack>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default PaymentLedgerTable;
